import React, { Component } from 'react'
import Calendar from './calendar/Calendar'

class MyCalendar extends Component {
  state = {
    width: window.innerWidth
  }

  componentWillMount() {
    window.addEventListener('resize', () =>
      this.setState({ width: window.innerWidth })
    )
  }

  getCalendarStyle() {
    return {
      color: '#000',
      width: '80%',
      zIndex: 1,
      position: 'relative'
    }
  }

  render() {
    const {
      onChange,
      minDate,
      maxDate,
      chosenDate,
      locale,
      language,
      availabilityStatus
    } = this.props
    //fixedPosition prop is a check on how big the screen is
    return (
      <Calendar
        firstDayOfWeek={1}
        language={language}
        DateTimeFormat={Intl.DateTimeFormat}
        locale={locale}
        onClickDay={(event, date) => onChange(event, date)}
        minDate={minDate}
        maxDate={maxDate}
        defaultDate={chosenDate}
        initialDate={chosenDate}
        yearBackground={'#fff'}
        style={this.getCalendarStyle()}
        availabilityStatus={availabilityStatus}
      />
    )
  }
}

export { MyCalendar }



// WEBPACK FOOTER //
// ./src/components/common/MyCalendar.js